import { RESET } from './forgotPasswordConstants'

export function reset() {
  return {
    type: RESET,
  }
}
